import { render, staticRenderFns } from "./infinite-scroll.vue?vue&type=template&id=45e57d83&lang=jade&"
import script from "./infinite-scroll.vue?vue&type=script&lang=js&"
export * from "./infinite-scroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports